define('ua/listeners/generic',[
    'ua/ua-wrapper',
    'ua/ua-config',
    'doneable',
    'adlhelpers'
], function(ua, config, Doneable, ADL) {
    'use strict';

    /**
     * EVENTS:
     *  pageview
     *  generic.error
     *  generic.modal
     *  generic.event
     *  generic.click
     *
     */
    function setupListeners(edap) {
        edap.on('pageview', function(data, setAsync, done) {
            var doneables = [],
                opts = {},
                adl = new ADL(data),
                listingid;

            setAsync();

            if (data.pagetype === 'property') {
                // custom metric 1 - PDP page view
                opts[ua.metricName(1)] = 1;
            }

            doneables.push(ua.sendPageview(data, opts));

            // TECHDEBT: we should eventually do away with this event
            if (data.propertydetails) {
                if (adl.shouldSet(adl.getListingIds())) {
                    listingid = adl.getListingIds();
                } else {
                    listingid = adl.get('propertyid');
                }

                doneables.push(ua.sendEvent(
                    'property attributes',
                    listingid,
                    data.propertydetails
                ));
            }

            Doneable.all(doneables).then(done);
        });

        edap.on('primary.action.rendered', function(data, setAsync, done) {
            var category = 'performance timing',
                name = 'primary.action.rendered';

            setAsync();

            // if it is explicitly called out as *not* the initial page in a single-page app,
            // append " (spa)" to the name to differentiate it from normal full page loads
            if (data.initialpageload === 'false') {
                name = name + ' (spa)';
            }

            ua.sendTiming(
                category,
                name,
                data.eventtime,
                undefined,
                undefined,
                data
            ).then(done);
        });

        edap.on('generic.error', function(data, setAsync, done) {
            setAsync();

            Doneable.all([
                ua.sendException(data.logmessage),
                ua.sendEvent(
                    'error',
                    data.appname,
                    data.logmessage,
                    undefined,
                    undefined,
                    data
                )
            ]).then(done);
        });

        edap.on('generic.modal', function(data, setAsync, done) {
            var shouldSendVPV = false,
                pageurl,
                pagetype;

            setAsync();

            // supports open events for inquiry and booking modals
            if (data.modalaction === 'open') {
                if (data.modalname === 'inquiry') {
                    pageurl = config.staticVPVs.inquirymodal;
                    shouldSendVPV = true;
                } else if (data.modalname === 'booking') {
                    pageurl = config.staticVPVs.bookingmodal;
                    shouldSendVPV = true;
                }
            }

            if (shouldSendVPV) {
                pagetype = [ // e.g. "property (inquiry modal)"
                    data.pagetype,
                    ' (',
                    data.modalname,
                    ' modal)'
                ].join('');

                ua.sendInteractionPageview(data, pageurl, pagetype).then(done);
            }
        });

        edap.on('generic.event', function(data, setAsync, done) {
            var adl = new ADL(data);

            setAsync();

            if (adl.isSetGet('highfrequency') === 'true') {
                done();
            } else {
                ua.sendEvent(
                    data.eventcategory,
                    data.eventaction,
                    data.eventlabel,
                    data.eventvalue,
                    undefined,
                    data
                ).then(done);
            }
        });

        edap.on('generic.click', function(data, setAsync, done) {
            setAsync();
            ua.sendEvent(
                data.eventcategory,
                data.eventaction + ' click',
                data.eventlabel,
                data.eventvalue,
                undefined,
                data
            ).then(done);
        });

        edap.on('test.exposure', function(data, setAsync, done) {
            setAsync();

            ua.sendEvent(
                'ab_testing',
                'test exposure',
                data.testname + ':' + data.variant
            ).then(done);
        });
    }

    return {
        setupListeners: setupListeners
    };
});

